import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchDentallyPatientLink } from '../utils/dentallyApi';

export default function useDentallyPatientLink(practiceId, leadId) {
  const [link, setLink] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [outcome, setOutcome] = useState('idle');
  const [reloadKey, setReloadKey] = useState(0);
  const generationRef = useRef(0);
  // Re-run the lookup for the same practice/lead (e.g. after linking a patient).
  const refresh = useCallback(() => setReloadKey((key) => key + 1), []);

  useEffect(() => {
    generationRef.current += 1;
    const generation = generationRef.current;
    setLink(null);
    setIsLoading(Boolean(practiceId && leadId));
    setOutcome(practiceId && leadId ? 'loading' : 'idle');
    if (!practiceId || !leadId) return undefined;

    fetchDentallyPatientLink(practiceId, leadId)
      .then((resolution) => {
        if (generation !== generationRef.current) return;
        const nextOutcome = ['unique', 'none', 'error', 'malformed', 'ambiguous'].includes(resolution?.outcome)
          ? resolution.outcome
          : 'malformed';
        setOutcome(nextOutcome);
        setLink(nextOutcome === 'unique' ? resolution?.link || null : null);
      })
      .catch(() => {
        if (generation === generationRef.current) {
          setLink(null);
          setOutcome('error');
        }
      })
      .finally(() => {
        if (generation === generationRef.current) setIsLoading(false);
      });

    return () => { generationRef.current += 1; };
  }, [practiceId, leadId, reloadKey]);

  return { link, isLoading, outcome, refresh };
}
